import { useContext } from "react";
import type { TopMenuContextType } from "../@types/contexts/TopMenu";
import { TopMenuContext } from "../contexts/TopMenuContext";

export const useTopMenu = (): TopMenuContextType => {
  const context = useContext(TopMenuContext);

  if (context === undefined) {
    throw new Error("useTopMenu must be used within a TopMenuProvider");
  }

  return context;
};
